/**
 * Kanal-Werte für Kommunikation (E-Mail, Brief, SMS, WhatsApp). API/Backend und Filter.
 * Anzeige über i18n (text/tr).
 */
export const CHANNEL_EMAIL = "Email";
export const CHANNEL_LETTER = "Letter";
export const CHANNEL_SMS = "SMS";
export const CHANNEL_WHATSAPP = "WhatsApp";

/** Klein geschrieben für channel-Keys wo API lowercase erwartet (z. B. "email", "letter"). */
export const CHANNEL_EMAIL_LC = "email";
export const CHANNEL_LETTER_LC = "letter";
